interface ExitToLandingOptions {
  navigate: () => void;
  onPersistFailure: () => void;
  persist?: () => Promise<void>;
}

export async function exitToLanding({
  navigate,
  onPersistFailure,
  persist,
}: ExitToLandingOptions): Promise<void> {
  try {
    await persist?.();
  } catch {
    onPersistFailure();
  }

  navigate();
}
